import React from "react";
import Footer from "./../components/footer";
import { Outlet } from "react-router-dom";
import Header from "./../components/header";
import { PulseLoader } from "react-spinners";
import { useSiteData } from "../context/SiteDataContext";

const MainLayout = () => {
  const { homedata, loading } = useSiteData();

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <PulseLoader
          color="#0d4571"
          loading={loading}
          size={8}
          aria-label="Diocese of Kurnool"
          data-testid="loader"
        />
      </div>
    );
  }

  return (
    <>
      <Header menudata={homedata?.headerdata} />
      <div style={{ minHeight: "66.5vh", padding: "10px" }}>
        <Outlet />
      </div>
      <Footer footerdata={homedata?.footerdata} />
    </>
  );
};

export default MainLayout;

